"use client";
import Image from "next/image";
import { usePathname } from "next/navigation";
import TryToolButton from "../../button/TryToolButton";

const images = [
  [
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1736260156/d249e3cf26261baed1c5780cf11a8d23_hdjiw6.png",
      width: 310,
      height: 496,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735807207/c3c5a9ba6b7e20f55490d57364e7359a_xzihpe.jpg",
      width: 310,
      height: 193,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735807208/7b894a9d309c737b88f04d0f6f954fb1_drbhsf.png",
      width: 310,
      height: 496,
    },
  ],
  [
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735807208/763f19626949885a1337dbed95b32a7e_sosema.png",
      width: 310,
      height: 398,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735807207/6bcb11c460ea7e757ee0f4657edc7c5a_xoqgr9.jpg",
      width: 310,
      height: 361,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735807207/7cbf3d05e0731bda1d4fead7cce438c9_xte6fb.jpg",
      width: 310,
      height: 552,
    },
  ],
  [
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735807414/91048de57026aa6602096689361fb16c_yosxja.jpg",
      width: 310,
      height: 310,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1736260156/3d93765680b9d653e02396a76f47b678_zfa9y4.png",
      width: 310,
      height: 524,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735807414/838189768991f5fcc2260e11ac3a5b1c_m1kudk.jpg",
      width: 310,
      height: 370,
    },
  ],
  [
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735807414/c5f08ae03a52045024e0c942d3dc6d23_hhh13u.png",
      width: 310,
      height: 310,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1736262280/image_26_1_drpeet.png",
      width: 310,
      height: 332,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735807407/a720cb676c384fec8063d334ee117afb_eyfz5m.png",
      width: 310,
      height: 349,
    },
  ],
];
const VecotrImages = [
  [
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1737475090/673794a87b1a1744c562c91c_Background_Border_2_-min-p-500_1_qn8ugs.png",
      width: 310,
      height: 524,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1737475090/65f95f15fa84f1d7f0b7a68f_modern-living-room-interior-_1_a9gera.png",
      width: 310,
      height: 310,
    },
  ],
  [
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1737475088/65f95f347d121832572b1297_white-letter--b--sans-serif-font--logo-design---st_1_1_yjy9nf.png",
      width: 310,
      height: 310,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1737475089/65f95f25a75084e0c16bb56a_minimalist-abstract-one-line-tusche-drawing-resemb-1_1_gou7dm.png",
      width: 310,
      height: 310,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1737475090/65f95f1d3098590248b9ce96_minimalist-abstract-one-line-tusche-drawing-resemb-2_1_vq6bwb.png",
      width: 310,
      height: 310,
    },
  ],
  [
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1737475087/65f95f5220b5a50f26c29c4d_cute-cartoon-man-running-2_1_mwk0vy.png",
      width: 310,
      height: 310,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1737476159/71f085b4-88f2-45ef-b1dc-ef3e8fe2b083_1_cradne.png",
      width: 310,
      height: 310,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1737475087/image_16_2_e0w8g1.png",
      width: 310,
      height: 310,
    },
  ],
  [
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1737475086/65f95f0bced0553d45db7828_modern-living-room-interior--1_1_ccynjw.png",
      width: 310,
      height: 310,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1737475086/image_15_1_ruepkc.png",
      width: 310,
      height: 310,
    },
    {
      src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1737475085/6583fc941d590139bcc993f7_656df0dce0d5c4a1d3b2cff7_zenergize-2_1_ss4awz.png",
      width: 310,
      height: 310,
    },
  ],
];

export default function BestGeneratedShots() {
  const path = usePathname();
  return (
    <div className="flex w-full flex-col items-center justify-center gap-5 bg-[#f7f4ff] py-8 sm:py-12 md:py-[50px]">
      <div className="flex flex-col items-center justify-center gap-[15px] py-2.5">
        <h2 className="max-w-[588px] text-center text-2xl font-semibold text-[#874bff] sm:text-3xl md:text-4xl">
          Our Best Generated Shots
        </h2>
      </div>
      {/* <div className="py-5 flex flex-wrap justify-center items-start gap-3 sm:gap-[15px]"> */}
      <div className="columns-2 gap-3 space-y-3 py-5 sm:gap-[15px] md:columns-3 lg:columns-4">
        {path === "/vector-generator" ? (
          <>
            {VecotrImages.map((column, columnIndex) => (
              <div
                key={columnIndex}
                className="flex flex-col items-start justify-start gap-3 sm:gap-[15px]"
              >
                {column.map((img, imgIndex) => (
                  <div key={imgIndex} className="w-full">
                    <Image
                      src={img.src}
                      alt={`Generated image ${columnIndex + 1}-${imgIndex + 1}`}
                      width={1000}
                      height={1000}
                      className="w-full max-w-[150px] rounded-[10px] object-cover sm:max-w-[200px] md:max-w-[250px] lg:hidden lg:max-w-[310px]"
                      style={{
                        height: `${img.height * 0.5}px`,
                        transition: "height 0.3s ease-in-out",
                      }}
                    />
                    <Image
                      src={img.src}
                      alt={`Generated image ${columnIndex + 1}-${imgIndex + 1}`}
                      width={1000}
                      height={1000}
                      className="w-full max-w-[150px] rounded-[10px] object-cover max-lg:hidden sm:max-w-[200px] md:max-w-[250px] lg:max-w-[310px]"
                      style={{
                        height: `${img.height}px`,
                        transition: "height 0.3s ease-in-out",
                      }}
                    />
                  </div>
                ))}
              </div>
            ))}
          </>
        ) : (
          <>
            {images.map((column, columnIndex) => (
              <div
                key={columnIndex}
                className="flex flex-col items-start justify-start gap-3 sm:gap-[15px]"
              >
                {column.map((img, imgIndex) => (
                  <div key={imgIndex} className="w-full">
                    <Image
                      src={img.src}
                      alt={`Generated image ${columnIndex + 1}-${imgIndex + 1}`}
                      width={1000}
                      height={1000}
                      className="w-full max-w-[150px] rounded-[10px] object-cover sm:max-w-[200px] md:max-w-[250px] lg:hidden lg:max-w-[310px]"
                      style={{
                        height: `${img.height * 0.5}px`,
                        transition: "height 0.3s ease-in-out",
                      }}
                    />
                    <Image
                      src={img.src}
                      alt={`Generated image ${columnIndex + 1}-${imgIndex + 1}`}
                      width={1000}
                      height={1000}
                      className="w-full max-w-[150px] rounded-[10px] object-cover max-lg:hidden sm:max-w-[200px] md:max-w-[250px] lg:max-w-[310px]"
                      style={{
                        height: `${img.height}px`,
                        transition: "height 0.3s ease-in-out",
                      }}
                    />
                  </div>
                ))}
              </div>
            ))}
          </>
        )}
      </div>
      {path === "/vector-generator" ? (
        <TryToolButton buttonText="Try Vector Generator" />
      ) : (
        <TryToolButton buttonText="Try Image Generator" />
      )}
    </div>
  );
}
